import { Button } from 'components';
import headerLogo from 'assets/images/svg/logo.svg';
import bcp from 'assets/images/svg/new-plan/header/bcp.svg';
import yape from 'assets/images/svg/new-plan/header/yape.svg';
import pacifico from 'assets/images/svg/new-plan/header/pacifico.svg';
import { useLocation } from 'react-router-dom';
import MirrorPageEnums from 'domains/new-plan/enums/mirror-page';
import './header.scss';
import { useHeader } from 'domains/new-plan/hooks/use-header';
interface HeaderProps {
  isFromCanal: boolean;
}

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { isFromCanal } = props;
  const location = useLocation();
  const { pathname } = location;
  const isFromYape = pathname === MirrorPageEnums.YAPE;
  const { handleSelectQuotation } = useHeader();

  return isFromCanal ? (
    <nav
      className={
        isFromYape
          ? 'new-plan-header-bcp background-yape'
          : ' new-plan-header-bcp'
      }
    >
      <div className="new-plan-header-bcp__content">
        <div className="new-plan-header-bcp__content__images">
          {isFromYape ? (
            <img
              className="new-plan-header-bcp__content__images__yape"
              src={yape}
              alt={yape}
            />
          ) : (
            <img
              className="new-plan-header-bcp__content__images__bcp"
              src={bcp}
              alt={bcp}
            />
          )}
          <img
            className="new-plan-header-bcp__content__images__pacifico"
            src={pacifico}
            alt={pacifico}
          />
        </div>
        <Button
          label="Solicítalo aqui"
          className={
            isFromYape
              ? 'new-plan-header-bcp__content__button background-button-yape'
              : 'new-plan-header-bcp__content__button'
          }
          onClick={() => handleSelectQuotation(pathname)}
        />
      </div>
    </nav>
  ) : (
    <nav className="new-plan-header">
      <div className="new-plan-header__content">
        <img
          className="new-plan-header__content__logo"
          src={headerLogo}
          alt={headerLogo}
        />
        <Button
          label="Solicítalo aqui"
          className="new-plan-header__content__button"
          onClick={() => handleSelectQuotation(pathname)}
        />
      </div>
    </nav>
  );
};

export default Header;

Header.defaultProps = {
  isFromCanal: false,
};
